import styled from 'styled-components'

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 200px;
  width: 100%;
  background: linear-gradient(
    184.67deg,
    rgba(72, 157, 254, 0.63) 1.89%,
    rgba(34, 7, 90, 0.42) 96.23%
  );
  background: rgba(16, 16, 44, 0.8);
  border: 1px solid rgba(73, 158, 255, 0.35);
  backdrop-filter: blur(10px);
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 20px;
  padding: 24px;
  color: white;
  @media (max-width: 768px) {
    padding: 20px 16px;
    border-radius: 12px;
  }
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
  @media (max-width: 768px) {
    padding-bottom: 14px;
    margin-bottom: 0px;
    gap: 3px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`
export const Border = styled.div`
  height: 1px;
  width: 100%;
  background: rgba(73, 158, 255, 0.35);
  background: linear-gradient(
    278.44deg,
    rgba(73, 158, 255, 0.35) 42.55%,
    rgba(95, 81, 255, 0.35) 84.23%
  );
  @media (max-width: 768px) {
    display: none;
  }
`
export const CardHeaderItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  @media (max-width: 768px) {
    gap: 3px;
  }
`

export const CardHeaderItemTitle = styled.h2`
  margin: 0;
  padding: 0;
  font-size: 18px;
  line-height: 27px;
`

export const CardHeaderItemText = styled.p`
  margin: 0;
  padding: 0;
  color: #7a97df;
`
export const CardHeaderItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${({ margin }) => {
    if (margin) {
      return margin
    }
    return '0'
  }};
  @media (max-width: 768px) {
    border-top: ${({ border }) => {
      if (border) {
        return '1px solid rgba(255, 255, 255, 0.1)'
      }
      return 'none'
    }};
    margin: ${({ mobileMargin }) => {
      if (mobileMargin) {
        return mobileMargin
      }
      return '0'
    }};

    padding: ${({ padding }) => {
      if (padding) {
        return padding
      }
      return '7px 0 0'
    }};
  }
`

export const CardBalance = styled.div`
  display: flex;
  flex-direction: column;
`

export const CardBalanceTitle = styled.p`
  margin: 0;
  padding: 0;
  color: #7a97df;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
`

export const CardIconLogo = styled.span`
  position: relative;
  left: 4px;
  top: 3px;
`

export const CardIconStaking = styled.img`
  width: 32px;
  height: 32px;
  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
  }
`

export const CardHistory = styled.div`
  @media (max-width: 768px) {
    display: ${({ isOpen }) => {
      if (isOpen) {
        return 'block'
      }
      return 'none'
    }};
  }
`
export const CardHistoryShowButton = styled.button`
  display: none;
  background: inherit;
  border: none;
  color: white;
  font-family: OpenSans, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  padding: 11px;
  @media (max-width: 768px) {
    display: block;
  }
`

export const CardHistoryIcon = styled.img`
  position: relative;
  left: 3px;
  top: 7px;
`

export const CardHistoryText = styled.p`
  text-transform: uppercase;
  font-size: 16px;
  font-style: italic;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.4x;
  text-align: center;
  color: white;
`

export const CardHistoryTextContainer = styled.div`
  background: linear-gradient(
      157.67deg,
      rgba(72, 157, 254, 0.63) 0.4%,
      rgba(34, 7, 90, 0.42) 87.86%
    )
    0.2%;
  opacity: 0.2;
  backdrop-filter: blur(5px);
  border-radius: 20px;

  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  @media (max-width: 768px) {
    opacity: 1;
    z-index: -1;
  }
`

export const CardHistoryTextWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 71px;
  box-sizing: border-box;
  margin-bottom: 14px;
  @media (max-width: 768px) {
    padding: 63px;
    margin-bottom: 0px;
  }
`

export const CardCharacterRatio = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.4px;
  text-align: left;
  margin: 12px 0;
`

export const CardCharacterIcon = styled.img`
  position: relative;
  top: 5px;
`

export const CardInfoTitle = styled.p`
  margin: 4px 0 4px;
  display: flex;
  align-items: center;
  color: #7a97df;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.4px;
  text-align: left;
  @media (max-width: 768px) {
    margin: 0;
    gap: 10px;
  }
`

export const CardInfo = styled.p`
  margin: 0 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0.4px;
  text-align: right;
  @media (max-width: 768px) {
    margin: 0;
  }
`

export const CardQuestionWrapper = styled.div`
  position: relative;
  right: -7px;
  height: 20px;
  @media (max-width: 768px) {
    right: 1px;
  }
`

export const CardQuestion = styled.img`
  cursor: pointer;
  &:hover {
  }
`

export const Tooltip = styled.div`
  border: transparent;
  position: absolute;
  top: -55%;
  left: 50%;
  transform: translate(-50%, -100%);
  padding: 4px 16px 6px;
  border-radius: 10px;
  background: white;
  box-shadow: 0 10px 21px 0 rgba(173, 182, 217, 0.3);
  border: none;
  width: 380px;
  transition: all 0.25s ease;

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.4px;
  text-align: center;
  color: black;
  visibility: hidden;
  opacity: 0;
  z-index: 2;
  ${CardQuestionWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
  &:after {
    content: '';
    border: transparent;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-top: 7px solid white;
    position: absolute;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
  }
  @media (max-width: 1000px) {
    max-width: 300px;
  }
  @media (max-width: 768px) {
    font-size: 12px;
    padding: 3px 8px 3px;
    max-width: 200px;
  }
`
